import React, { useState } from "react";
import BrightIdea from "./PostTypes/BrightIdea";
import Celebration from "./PostTypes/Celebration";
import NotSupported from "./PostTypes/NotSupported";
import Status from "./PostTypes/Status";
import Checkin from "./PostTypes/Checkin";
import TeamVideo from "./PostTypes/TeamVideo";
import Slideshow from "./PostTypes/Slideshow";
import Welcome from "./PostTypes/Welcome";
import WaterCooler from "./PostTypes/WaterCooler";
import Poll from "./PostTypes/Poll";
import TodoList from "./PostTypes/TodoList";
import TodoListItem from "./PostTypes/TodoListItem";
import ReTeamMeeting from "./PostTypes/ReTeamMeeting";
import Trivia from "./PostTypes/Trivia";
import Course from "./PostTypes/Course";
import Survey from "./PostTypes/Survey";

export default ({ post }) => {
  const [noPostContent] = useState(["checkin.reply"]);
  const [components] = useState({
    celebration: Celebration,
    brightidea: BrightIdea,
    text: Status,
    topic: Status,
    checkin: Checkin,
    slideshow: Slideshow,
    teamvideo: TeamVideo,
    welcomemessage: Welcome,
    watercooler: WaterCooler,
    poll: Poll,
    "todo-list": TodoList,
    "todo-list-item": TodoListItem,
    trivia: Trivia,
    notsupported: NotSupported,
    "reteam-meeting" : ReTeamMeeting,
    coursecreation: Course,
    survey: Survey
  });

  if (noPostContent.includes(post?.type)) {
    return null;
  }
  const PostType = components[post.type] ?? components["notsupported"];

  return (
    <div className="post-content">
      <PostType post={post} />
    </div>
  );
};
